import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle_add",
  "use": "circle_add-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle_add\">\n<path d=\"M8 15H22\" stroke=\"#424242\" />\n<path d=\"M15 22L15 8\" stroke=\"#424242\" />\n<rect x=\"0.5\" y=\"0.5\" width=\"29\" height=\"29\" rx=\"14.5\" stroke=\"#424242\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol